var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: {
        "has-crossprice":
          _vm.hasCrossPrice ||
          (!!_vm.currentOffer &&
            _vm.item != null &&
            _vm.item.item.id == _vm.currentVariation.item.id &&
            _vm.isActiveByStock),
        "is-specialoffer":
          !!_vm.currentOffer &&
          _vm.item != null &&
          _vm.item.item.id == _vm.currentVariation.item.id &&
          _vm.isActiveByStock,
      },
    },
    [
      !!_vm.currentOffer &&
      _vm.item != null &&
      _vm.item.item.id == _vm.currentVariation.item.id &&
      _vm.isActiveByStock
        ? [
            _c("div", { staticClass: "offer-countdown" }, [
              !!_vm.duration
                ? _c(
                    "div",
                    { staticClass: "live-shopping-countdown-heading" },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$translate(
                              "Ceres::Template.liveShoppingOfferEndsIn"
                            )
                          ) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !!_vm.duration
                ? _c(
                    "div",
                    { staticClass: "live-shopping-countdown-thread-container" },
                    [
                      _c(
                        "div",
                        { staticClass: "live-shopping-countdown-thread" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "live-shopping-countdown-thread-number offer-hours",
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.duration.hours) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "small" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.liveShoppingHours"
                                  )
                                ) +
                                "\n          "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "live-shopping-countdown-thread" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "live-shopping-countdown-thread-number offer-minutes",
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.duration.minutes) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "small" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.liveShoppingMinutes"
                                  )
                                ) +
                                "\n          "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "live-shopping-countdown-thread" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "live-shopping-countdown-thread-number offer-seconds",
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.duration.seconds) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "small" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.liveShoppingSeconds"
                                  )
                                ) +
                                "\n          "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", [
        _vm.showCrossPrice &&
        _vm.hasCrossPrice &&
        _vm.currentVariation.prices.rrp &&
        _vm.currentVariation.prices.rrp.unitPrice.value > 0
          ? _c("div", { staticClass: "crossprice" }, [
              _c("span", { staticClass: "text-muted small text-appearance" }, [
                _vm._v(
                  _vm._s(_vm.$translate("Ecomsilio::Template.oldPrice")) + ": "
                ),
                _c("del", [
                  _vm._v(
                    _vm._s(_vm.currentVariation.prices.rrp.unitPrice.formatted)
                  ),
                ]),
              ]),
            ])
          : _vm.showCrossPrice && _vm.hasSpecialOffer
          ? _c("div", { staticClass: "crossprice" }, [
              _c(
                "span",
                { staticClass: "text-muted small text-appearance" },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$translate("Ecomsilio::Template.oldPrice")) +
                      ": "
                  ),
                  _c("del", [
                    _vm._v(
                      _vm._s(
                        _vm.currentVariation.prices.default.unitPrice.formatted
                      )
                    ),
                  ]),
                  !isNaN(_vm.itemPriceRebatePercentage) &&
                  _vm.itemPriceRebatePercentage > 0
                    ? [
                        _vm._v(
                          " (- " + _vm._s(_vm.itemPriceRebatePercentage) + " %)"
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "price h1",
            class: { "is-special-offer": _vm.hasSpecialOffer },
          },
          [
            _vm.showDynamicPrice
              ? [
                  _vm._v(
                    _vm._s(
                      _vm.$translate("Ceres::Template.dynamicVariationPrice", {
                        price: _vm.$options.filters.currency(
                          _vm.variationTotalPrice,
                          _vm.currentVariation.prices.default.currency
                        ),
                      })
                    )
                  ),
                ]
              : [
                  _vm._v(
                    _vm._s(
                      _vm._f("currency")(
                        _vm.variationTotalPrice,
                        _vm.currentVariation.prices.default.currency
                      )
                    )
                  ),
                ],
            _c("sup", [_vm._v("*")]),
          ],
          2
        ),
        _vm._v(" "),
        _vm.currentVariation.prices.default.lowestPrice.value &&
        _vm.showCrossPrice &&
        _vm.hasCrossPrice
          ? _c("div", { staticClass: "lowest-price text-muted mb-3" }, [
              _c("div", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$translate("Ceres::Template.singleItemLowestPrice", {
                      price:
                        _vm.currentVariation.prices.default.lowestPrice
                          .formatted,
                    })
                  ),
                },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.currentVariation.unit
          ? _c(
              "div",
              {
                staticClass: "base-price text-muted my-3",
                class: {
                  "is-single-piece":
                    _vm.currentVariation.unit &&
                    _vm.currentVariation.unit.content === 1 &&
                    _vm.currentVariation.unit.unitOfMeasurement === "C62",
                },
              },
              [
                _c("div", [
                  _vm._v(
                    _vm._s(
                      _vm.$translate("Ceres::Template.singleItemContent")
                    ) + ": "
                  ),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm._f("numberFormat")(
                          _vm.currentVariation.unit.content
                        )
                      ) + " "
                    ),
                  ]),
                  _c("span", [
                    _vm._v(_vm._s(_vm.currentVariation.unit.names.name)),
                  ]),
                ]),
                _vm._v(" "),
                _vm.currentVariation.variation.mayShowUnitPrice
                  ? _c("div", [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$translate(
                              "Ceres::Template.singleItemUnitPrice"
                            )
                          ) +
                          ":\n        "
                      ),
                      _c("span", { staticClass: "base-price-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("specialOffer")(
                              _vm.variationGraduatedPrice.basePrice,
                              _vm.currentVariation.prices,
                              "basePrice"
                            )
                          )
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]
            )
          : _vm._e(),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }